import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import {
  API_URL_SITE_LIST,
  API_URL_SITE_DASHBOARD,
  API_URL_DASHBOARD_LIST,
  API_URL_DASHBOARD_SITE_TYPES,
} from 'constants/index'
import UrlHelper from 'helpers/url'
import {
  FETCH_SITES,
  FETCH_SITE,
  DISPLAY_SITES,
  DASHBOARD_MAP_OPEN_INFOWINDOW,
  SET_STATISTIC_DATA,
  FETCH_STATISTIC_DATA,
  FETCH_DASHBOARD_SITE_TYPE,
  FETCH_DASHBOARD_SITE_TYPE_SUCCESS,
} from './reducer'

function* getSiteList(action) {
  try {
    const { startDate, endDate, type } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(`${API_URL_DASHBOARD_LIST}/${type}`, {
        ...{ startDate, endDate, type },
      }),
    })
    yield put({ type: DISPLAY_SITES, sites: response })
  } catch (error) {
    console.log('DASHBOARD ERROR', error)
  }
}

function* getSiteTypeList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_DASHBOARD_SITE_TYPES),
    })
    yield put({ type: FETCH_DASHBOARD_SITE_TYPE_SUCCESS, types: response })
  } catch (error) {
    console.log('DASHBOARD ERROR', error)
  }
}

function* getSiteInfo(action) {
  try {
    const { id, marker, startDate, endDate } = action.payload
    const siteInfo = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_SITE_DASHBOARD, {
        ...{ id, startDate, endDate },
      }),
    })

    siteInfo.marker = marker
    yield put({ type: DASHBOARD_MAP_OPEN_INFOWINDOW, payload: siteInfo })
  } catch (error) {
    console.log('DASHBOARD ERROR', error)
  }
}

function* fetchStatData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_SITE_LIST}${UrlHelper.getPsfsQuery(action.payload)}`,
    })
    yield put({ type: SET_STATISTIC_DATA, statistic: response })
  } catch (error) {
    console.log('DASHBOARD ERROR', error)
  }
}

function* siteSaga() {
  yield takeLatest(FETCH_SITES, getSiteList)
  yield takeLatest(FETCH_DASHBOARD_SITE_TYPE, getSiteTypeList)
  yield takeLatest(FETCH_SITE, getSiteInfo)
  yield takeLatest(FETCH_STATISTIC_DATA, fetchStatData)
}

export default siteSaga
